import { FC } from 'react';

import { Box } from '@mui/material';
import { ToastContentProps } from 'react-toastify/dist/types';

import { Button } from 'components/_basic/Button/Button';

import s from './inactivityHandler.module.scss';

export const InactivityToastMessage: FC<Partial<ToastContentProps>> = ({
  closeToast
}) => {
  const handleButtonClick = () => {
    closeToast?.();
  };

  return (
    <Box
      className={s.inactivityToastContentWrapper}
    >
      <span
        className={s.inactivityToastContentText}
      >
        No activity last hour. Are you still here?
      </span>
      <Button
        className={s.inactivityToastContentButton}
        variant="text"
        onClick={handleButtonClick}
      >
        Yes
      </Button>
    </Box>
  );
};
